import { fetchApi } from '@/config/api';
import { RemiseApi, CreateRemiseInput, UpdateRemiseInput } from '@/types/discount';

// Fonctions API pour les remises
export async function getRemises(vendeurId?: number, remiseType?: number): Promise<RemiseApi[]> {
  // Si pas d'ID vendeur, utiliser la query simple (pour compatibilité)
  if (!vendeurId) {
    const query = `
      query GetRemises {
        remises {
          id_remise
          titre
          montant_min
          montant_max
          montant
          pourcentage
          actif
          supprimer
          id_remise_type
        }
      }
    `
    
    const result = await fetchApi<{ remises: RemiseApi[] }>(query)
    return result.remises
  }

  // Utiliser la query filtrée par vendeur
  const query = `
    query GetRemisesByVendeur($filter: FilterRemiseInput!) {
      remisesPage(filter: $filter) {
        items {
          id_remise
          titre
          montant_min
          montant_max
          montant
          date_debut
          date_fin
          pourcentage
          actif
          supprimer
          id_remise_type
        }
        total
      }
    }
  `
  
  const filter: Record<string, number> = {
    id_vendeur: vendeurId,
    supprimer: 0 // Seulement les remises non supprimées
  }
  
  // Ajouter le filtre par type de remise si spécifié
  if (remiseType) {
    filter.id_remise_type = remiseType
  }
  
  const result = await fetchApi<{ remisesPage: { items: RemiseApi[], total: number } }>(query, {
    filter
  })
  
  return result.remisesPage.items
}

export async function createRemise(input: CreateRemiseInput): Promise<RemiseApi> {
  const mutation = `
    mutation CreateRemise($input: CreateRemiseInput!) {
      createRemise(input: $input) {
        id_remise
        titre
        montant_min
        montant_max
        montant
        date_debut
        date_fin
        pourcentage
        actif
      }
    }
  `
  
  const result = await fetchApi<{ createRemise: RemiseApi }>(mutation, { input })
  return result.createRemise
}

export async function updateRemise(input: UpdateRemiseInput): Promise<boolean> {
  const mutation = `
    mutation UpdateRemise($input: UpdateRemiseInput!) {
      updateRemise(input: $input) {
        id_remise
        actif
      }
    }
  `
  
  await fetchApi(mutation, { input })
  return true
}

export async function deleteRemise(id: number): Promise<boolean> {
  // Utiliser la mutation dédiée côté backend qui effectue un soft delete
  const mutation = `
    mutation RemoveRemise($id: Int!) {
      removeRemise(id: $id)
    }
  `

  const result = await fetchApi<{ removeRemise: boolean }>(mutation, { id })
  return !!result.removeRemise
}
